import type { UserFromDb } from "shared"
import EvoIcon from "shared/src/images/EvoIcon.png"

export type UserBadgeKind = "evo" | "both" | "integration" | null

// Cognito subs are UUIDs (exactly 36 chars).
// Integration-only userIds (User.new_from_external_id) are `<client_uuid>_<12_hex>` = 49 chars.
// Legacy pre-migration userIds are < 36 chars.
const COGNITO_SUB_LENGTH = 36

export function getUserBadgeKind(user: UserFromDb | undefined): UserBadgeKind {
	if (user == null) return null
	if (user.evoRef != null) return "evo"
	if (user.externalId == null) return null
	const isCognitoUser = user.userId?.length === COGNITO_SUB_LENGTH
	return isCognitoUser ? "both" : "integration"
}

interface UserBadgeProps {
	readonly user?: UserFromDb
	readonly showSso?: boolean
}

export function UserBadge({ user, showSso = false }: UserBadgeProps): JSX.Element | null {
	const ssoEnabled = showSso && user?.apiKey != null && user.apiKey !== "aid#None"
	const badgeKind = getUserBadgeKind(user)

	if (badgeKind === "evo") {
		return <img src={EvoIcon} alt="Evo" style={{ height: 25 }} />
	}
	if (ssoEnabled) {
		return (
			<div
				style={{
					backgroundColor: "var(--ara-green)",
					color: "white",
					fontWeight: "bold",
					padding: "5px",
					borderRadius: "4px",
				}}>
				SSO
			</div>
		)
	}
	if (badgeKind === "both") {
		return (
			<div
				style={{
					backgroundColor: "var(--ara-purple)",
					color: "white",
					fontWeight: "bold",
					padding: "5px",
					borderRadius: "4px",
				}}>
				Both
			</div>
		)
	}
	if (badgeKind === "integration") {
		return (
			<div
				style={{
					backgroundColor: "var(--ara-gold)",
					color: "white",
					fontWeight: "bold",
					padding: "5px",
					borderRadius: "4px",
				}}>
				Integration
			</div>
		)
	}

	return null
}
